<template>
  <pull-refresh
    style="min-height: 100vh"
    v-model="isLoading"
    @refresh="onRefresh"
  >
    <div inset class="is-have-plate">
      <van-radio-group v-model="hasPlate" direction="horizontal">
        <van-radio :name="false">无牌车</van-radio>
        <van-radio :name="true">
          有牌车
        </van-radio>
      </van-radio-group>
    </div>
    <div v-if="!hasPlate">
      <div class="top">
        <div class="img">
          <img :src="userInfo.img" />
        </div>
        <div>
          <div class="nickname">昵称：{{ userInfo.nickname }}</div>
        </div>
      </div>
      <div class="list">
        <div class="item">
          <div class="left">停车场：</div>
          <div class="right">{{ detail.lot_name }}</div>
        </div>
        <div class="item">
          <div class="left">设备：</div>
          <div class="right">{{ detail.device_name }}</div>
        </div>
      </div>
      <div class="list">
        <div class="item">
          <div class="left">车牌号：</div>
          <div class="right">{{ detail.car_no }}</div>
        </div>
        <div class="item">
          <div class="left">入场时间：</div>
          <div class="right">{{ detail.starttime }}</div>
        </div>
      </div>
    </div>
    <div v-else class="sign-plate-container">
      <div class="title">
        {{ detail.lot_name || '住云停车场' }}
      </div>
      <LicensePlate v-model="licensePlate" />
      <div class="tel">
        <span class="label">
          <span class="required">*</span>
          <span>手机号：</span>
        </span>
        <input
          v-model="tel"
          placeholder="请输入手机号"
          :maxlength="11"
          type="tel"
        />
      </div>
      <button class="submit-button" :disabled="submitting" @click="onSubmit">
        提交
      </button>
    </div>
    <van-dialog v-model="show" title=" " @confirm="List">
      请确认以无牌车身份入场
    </van-dialog>
  </pull-refresh>
</template>

<script>
import {
  getEnterList,
  getIsNeedSign,
  getLicensePlate,
  visitorRegistration,
} from '../api/api';
import { Toast, PullRefresh, Dialog, Radio, RadioGroup } from 'vant';
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {
    // Tag,
    // Button,
    PullRefresh,
    [Dialog.Component.name]: Dialog.Component,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  data() {
    return {
      detail: {},
      isLoading: false,
      show: false,
      hasPlate: false,
      is_visitor_registration: false,
      licensePlate: '',
      tel: '',
      submitting: false,
      listTimer: null,
      isHasPlate: false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    device_id() {
      return this.userInfo.device_id;
    },
  },
  watch: {
    device_id: {
      handler(v) {
        v && this.fetchIsNeedSign();
      },
      immediate: true,
    },
    hasPlate: {
      handler(v) {
        if (!v && !this.isHasPlate) {
          this.show = true;
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    async List() {
      try {
        if (this.listTimer) {
          clearTimeout(this.listTimer);
        }
        this.listTimer = setTimeout(async () => {
          let value = {};
          this.userInfo.wx_zfb === 'zfb'
            ? (value = {
                ...value,
                user_id: this.userInfo.user_id,
                wx_zfb: this.userInfo.wx_zfb,
              })
            : (value = {
                ...value,
                openid: this.userInfo.openid,
                wx_zfb: this.userInfo.wx_zfb,
              });
          const { data } = await getEnterList({ ...value });
          this.detail = data;
        }, 300);
      } catch {}
    },
    onRefresh() {
      this.List();
      setTimeout(() => {
        Toast('刷新成功');
        this.isLoading = false;
      }, 1000);
    },
    async fetchIsNeedSign() {
      try {
        const { data } = await getIsNeedSign({ device_id: this.device_id });
        this.is_visitor_registration = data.is_visitor_registration;
        if (data.is_visitor_registration) {
          this.hasPlate = true;
          this.show = false;
          this.fetchLicensePlate();
        } else {
          this.show = true;
        }
      } catch (error) {
        this.show = true;
      }
    },
    async fetchLicensePlate() {
      const { data } = await getLicensePlate({ device_id: this.device_id });
      this.licensePlate = data.car_no;
    },
    async onSubmit() {
      if (!this.licensePlate) {
        Toast('请输入车牌号');
        return;
      } else if (!this.tel) {
        Toast('请输入手机号');
        return;
      }
      this.submitting = true;
      const params = {
        tel: this.tel,
        car_no: this.licensePlate,
        device_id: this.device_id,
      };
      const toast = Toast.loading({
        duration: 1000,
        message: '登记提交中...',
      });
      const { data } = await visitorRegistration(params);
      this.isHasPlate = true;
      this.detail = data;
      this.$nextTick(() => {
        Toast('登记成功');
        this.hasPlate = false;
        this.submitting = false;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  height: 100%;
  background-color: #f1f1f1;
}
.is-have-plate {
  padding: 12px 10px;
  margin: 5px 0;
  background: #fff;
}

.sign-plate-container {
  background: #fff;
  padding: 12px 10px;

  .title {
    display: flex;
    align-items: center;
    line-height: 1em;
    margin: 6px 0 12px;
    font-weight: 600;

    &::before {
      content: ' ';
      display: block;
      width: 4px;
      height: 1em;
      margin-right: 6px;
      background: #1989fa;
    }
  }

  .tel {
    position: relative;
    max-width: 100%;
    overflow: hidden;
    box-sizing: content-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-top: 20px;

    .label {
      font-weight: 600;
      line-height: 1em;
      .required {
        color: red;
        font-weight: 400;
      }
    }

    input {
      position: relative;
      padding: 7px;
      box-sizing: border-box;
      border-radius: 5px;
      border: 1px solid #cdcdcd;
      width: calc(100%);
    }
  }

  .submit-button {
    width: 100%;
    height: 40px;
    background-color: #1989fa;
    color: #fff;
    font-weight: 600;
    font-size: 1rem;
    border-radius: 5px;
    border: 0;
    margin-top: 10px;
  }
}
.unpayment {
  .title {
    margin-top: 1.85rem;
    padding: 1rem;
    text-align: left;
    background-color: #fff;
    margin-bottom: 0.1rem;
    .text {
      font-weight: 700;
    }
  }
  .order-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .card-plate {
      text-align: left;
      font-size: 1rem;
      padding-bottom: 10rpx;
    }

    .card-title {
      font-size: 0.8rem;
      color: #8b8b8b;
      padding-left: 10rpx;
    }

    .card-price {
      font-size: 1rem;
      color: #858585;
      text-align: center;
    }
  }
  .car-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .tag {
      margin-right: 0.5rem;
    }
    .del-button {
      height: 40px;
      width: 50px;
      padding: 0px 10px;
      font-size: 12px;
      margin-top: 5px;
      border-radius: 5px;
    }
  }
}
.top {
  margin-bottom: 0.5rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  .img {
    margin: 0.5rem;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
  .nickname {
    font-size: 1rem;
    margin-bottom: 0.2rem;
    font-weight: 500;
  }
  .openId {
    font-size: 0.5rem;
    color: darkgoldenrod;
  }
}
.list {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  .item {
    background-color: #fff;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 2.5rem;
    text-align: left;
    .left {
      width: 5rem;
      margin-left: 0.7rem;
    }
    .right {
      color: #8a8787;
    }
  }
}
.tips {
  font-size: 0.9rem;
  text-align: left;
  background-color: #fff;
  padding: 0.5rem;
  .title {
    line-height: 2.5rem;
    height: 2.5rem;
    border-bottom: 1px solid #f1f1f1;
  }
  .content {
    line-height: 2.5rem;
    height: 2.5rem;
    color: #8a8787;
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 3rem;
  line-height: 3rem;
  background-color: #fff;
  width: 100%;
  .box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .left {
      text-align: left;
      width: 60%;
      margin-left: 0.5rem;
      .title {
        font-weight: 600;
        font-size: 1rem;
      }
      .price {
        color: red;
        font-weight: 600;
        font-size: 0.9rem;
      }
    }
    .right {
      width: 40%;
      background-color: #d0ad65;
      font-weight: 600;
      font-size: 1rem;
      color: #5d5128;
    }
  }
}
.van-dialog {
  line-height: 40px;
}
</style>
